import { ContactPrefix, CountryCode, CountryName, CountryUrl } from '@/enums';
import { getRoute } from './RouteHelper';

export const showComponent = {
  [CountryCode.Malaysia]: true,
  [CountryCode.Philippines]: false,
};

const getCountryUrl = () => {
  if (typeof window !== 'undefined') {
    const { country } = getRoute(window.location.pathname);
    return country;
  } else {
    return CountryUrl.Malaysia;
  }
};

export const getCountryCode = () => {
  return {
    [CountryUrl.Malaysia]: CountryCode.Malaysia,
    [CountryUrl.Philippines]: CountryCode.Philippines,
  }[getCountryUrl()];
};

export const getCountryName = () => {
  return {
    [CountryUrl.Malaysia]: CountryName.Malaysia,
    [CountryUrl.Philippines]: CountryName.Philippines,
  }[getCountryUrl()];
};

export const getContactPrefix = () => {
  return {
    [CountryUrl.Malaysia]: ContactPrefix.Malaysia,
    [CountryUrl.Philippines]: ContactPrefix.Philippines,
  }[getCountryUrl()];
};
